import React from 'react'
import Heading from '../../components/Heading'
import Contact from '../../components/Contact'
import { Grid, Col } from '../../components/Grid'
import { Link } from 'react-router-dom'

import cases from '../../data/cases'
import Helmet from '../../components/seo/Helmet'

export default function Work ({ helmetProps }) {
  return (
    <article>
      <Helmet {...helmetProps} />
      <h1>Referanser</h1>

      {cases
        .filter(({ promoted }) => promoted)
        .map(({ slug, name, preamble, cta, description }) => (
          <Grid list key={slug}>
            <Col>
              <h2>{name}</h2>
              <p>
                <em>{preamble}</em>
              </p>
            </Col>
            <Col>
              <p
                dangerouslySetInnerHTML={{ __html: description.props.children }}
              />
              <Link to={`/arbeid/${slug}`}>{cta}</Link>
            </Col>
          </Grid>
        ))}

      <Heading small spaced>
        Andre vi jobber med
      </Heading>

      <Grid>
        {cases
          .filter(({ promoted }) => !promoted)
          .map(({ name, preamble }, index) => (
            <Col multiple key={index}>
              <h3>{name}</h3>
              <p>{preamble}</p>
            </Col>
          ))}
      </Grid>

      <Contact
        who="tor"
        title="Lurer du på noe, eller vil du ta en prat om oppdrag?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du du har spørsmål om hva
        Appresso kan levere.
      </Contact>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Work/index.js